import styled from '@emotion/styled';
import { device } from '@landsbankinn/ui';
import * as React from 'react';
import type { fetchFund_node_Fund } from '../../../../graphql/__generated__/fetchFund';
import { MarketsBody } from '../../shared/MarketsComponents';

export const FundTypeInfoContainer = styled.div`
  background-color: rgb(244, 247, 247);
  margin-top: 20px;
  padding: 60px 0px;
  margin-bottom: 0px;

  p:last-of-type {
    padding-top: 24px;
  }

  @media ${device.tablet} {
    padding: 75px 100px 69px 100px;
  }
`;

interface IProps {
  fund: fetchFund_node_Fund;
  ucitsDescription: string[];
  nonUcitsDescription: string[];
}

export function FundTypeInformation({
  fund,
  ucitsDescription,
  nonUcitsDescription,
}: IProps) {
  return (
    <FundTypeInfoContainer>
      {fund.details?.ucitsClassification
        ?.toLocaleLowerCase()
        .includes('non-ucits')
        ? nonUcitsDescription?.map((paragraph, i) => (
            <MarketsBody key={i}>{paragraph}</MarketsBody>
          ))
        : ucitsDescription?.map((paragraph, i) => (
            <MarketsBody key={i}>{paragraph}</MarketsBody>
          ))}
    </FundTypeInfoContainer>
  );
}
